<template lang="pug">
v-container.py-0(fluid fill-height)
  v-row.h100
    v-col.pa-0.banner__background(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''")
      v-row.h100.banner__image-container(align="center" justify="center" no-gutters)
        .banner__image.h100.w100(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''")
        v-col.text-center.project-name__container(cols="12")
          v-icon.geodis-banner.white--text(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''") $geodis
        v-icon.vectorLines(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''") $vectorLines
        h6.iconRounded--text.version(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''") {{formattedVersion}}
    v-col.colForm.pa-0
      v-row.ma-0.h100(align="center" justify="center")
        v-card.login__card(elevation="0", width="630" :class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''")
          v-row
            v-col.justify-center
              h1.card__title.primary--text eOrder
              .g-divider
              //- v-divider.primary.g-divider
              h1.card__subtitle.primary--text Welcome
          //- v-row.justify-center
          v-row.card__actions.justify-center.align-center
            g-btn.card--action(v-if="!$hasEmbeddedQuery($route)" @click="SAMLLogin", color="primary", :disabled="loading")
              |Login
              v-icon(right) $arrowRightRounded
        .lines-container(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''")
          v-icon.lineSCO(:class="($vuetify.breakpoint.smAndDown) ? 'sm' : ''") $lineSCO
</template>

<style lang="scss" scoped>
.banner__image-container {
  overflow: hidden;
  position: relative;
}
.banner__image {
  background: url('../assets/backsky.png') var(--v-background-base);
  background-repeat: no-repeat;
  background-size: 430px 900px;
  opacity: 0.7;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  &.sm {
    background-size: auto auto;
  }
}
.banner__background {
  background-color: var(--v-primary-base);
  max-width: 430px;
  width: 430px;
  &.sm {
    max-width: none;
    width: auto;
  }
}
.form {
  margin: 43px 0px 0px 80px;
  width: 100%;
}
.h100 {
  height: 100%;
}
.v-card {
  max-width: 700px;
  width: 100%;
  max-height: 476px;
  height: 100%;
  padding: 43px 30px 75px 41px;
}
.field {
  max-width: 300px;
}
.card__title {
  font-size: 72px;
  line-height: 72px;
  text-align: center;
  margin-bottom: 16px;
}
.card__subtitle {
  margin-top: 26px;
  font-size: 36px;
  line-height: 36px;
  text-align: center;
}
.card__actions {
  margin-top: 112px;
}
.g-divider {
  height: 0.5px;
  background-color: #3200E6;
}
.login__card {
  top: -10px;
  &.sm {
    height: auto;
  }
}
.legend {
  display: block;
  margin-bottom: 31px;
  visibility: hidden;
}
.g-btn.card--action {
  width: 139px;
  height: 40px;
}
.colForm {
  // width: 1010px;
  position: relative;
  // background-color: var(--v-background-base);
}
.lines-container {
  position: absolute;
  bottom: 17%;
  left: 0;

  &.sm {
    bottom: 0;
  }

  &:after {
    position: absolute;
    content: "";
    height: 2px;
    background-color: #D0D1D4;
    width: 50%;
    top: 32px;
  }
}
.lineSCO {
  height: 62px;
  width: 1010px;
  color: #D0D1D4;
  &.sm {
    width: 100%;
  }
}
.project-name {
  font-family: Avenir LT;
  font-style: normal;
  font-weight: 900;
  font-size: 60px;
  line-height: 72px;
  margin-bottom: 22px;
}
.geodis-banner {
  height: 160px;
  width: 160px;
  top: -65px;
  &.sm {
    top: auto;
  }
}
.project-name__container {
  z-index: 2;
}
.vectorLines {
  height: 53px;
  width: 430px;
  position: absolute;
  top: 75vh;
  color: #D0D1D4;
  &.sm {
    display: none;
  }
}
.version {
  position: absolute;
  bottom: 25px;
  opacity: 0.7;
  &.sm {
    position: unset;
  }
}
</style>

<script>
import { VTextField } from 'vuetify/lib/components'
import axios from 'axios'

export default {
  components: {
    VTextField
  },
  data () {
    return {
      visible: false,
      errors: '',
      user: {
        email: '',
        password: ''
      },
      buildInfo: {
        version: null,
        dateBuild: null,
      },
      loading: false,
    }
  },
  methods: {
    SAMLLogin() {
      try{
        window.location.replace('/EORDER/api/Auth/InitiateSingleSignOn');
      } catch(exception)
      {
        console.log(this.$cleanString(exception));
      }
    },
    async redirectIfNeeded() {
      let tokenSAML = _.get(this.$route, 'query.access_token');
      let userData = this.$getStorageUser()
      let embeddedRoute = `/${this.$scope()}/embeddable/${this.toScreen || ''}`
      if(tokenSAML) {
        await this.getUserData(tokenSAML);
        userData = this.$getStorageUser()
      }
      if (_.get(userData, 'token')) {
        if(!this.$hasEmbeddedQuery(this.$route)) {
          let defaultScreen = _.get(userData, 'user.defaultScreen');
          if(!defaultScreen || defaultScreen=='Workstation') defaultScreen = '';
          this.$router.push(`/${this.$scope()}/${defaultScreen || ''}`);
        } else {
          console.log(`[ROUTER][HAS TOKEN] TO EMBEDDED SCREEN`)
          embeddedRoute = this.correctEmbeddableRoute(embeddedRoute, userData.user, this.toScope)
          this.$router.push(embeddedRoute);
        }
      } else if(this.$hasEmbeddedQuery(this.$route)) {
        console.log(`[ROUTER][TOKEN] TO IDP`)
        window.location.replace(`${process.env.VUE_APP_API_ABSOLUTE}/Auth/InitiateSingleSignOn?embeddedLogin=True&screen=${this.toScreen}&scope=${this.toScope}`);
      }
    },
    correctEmbeddableRoute(embeddedRoute, user, toScope) {
      if (toScope && this.$hasBusinessScope(user, toScope)) {
        this.$selectBusinessScope(this.$getBusinessScopeFromUser(user, toScope), this.$store);
        embeddedRoute = `/${this.$scope()}/embeddable/${this.toScreen || ''}`
      } else if (toScope && !this.$hasBusinessScope(user, toScope))
        embeddedRoute = `/embeddable/scope-error`
      return embeddedRoute
    },
    async getUserData(tokenSAML) {
      try {
        this.loading = true;
        const { data: userData } = await axios.request({
          url: '/me',
          method: 'get',
          params: {
            load: [ 'UserRoleBusinessScopes' ]
          },
          headers: {
            common: {
              Authorization: `Bearer ${tokenSAML}`,
            },
          },
        });
        let user = {user: userData, token: tokenSAML};
        axios.defaults.headers.common.Authorization = `Bearer ${user.token}`;
        const { data: config } = await axios.get(`user/configuration/${user.user.uid}`);

        this.$store.commit('USER', user);
        this.$store.commit('CONFIG', config);
        this.$selectBusinessScope(user.user.defaultBusinessScope);
        await this.$updateSchema(this.$store, axios)
        let { user: { defaultScreen } } = user;
      } catch(e) {
        console.log(this.$cleanString(e));
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    formattedVersion() {
      // return `Version ${this.buildInfo.version || 'x.x.x'} ${this.buildInfo.dateBuild || 'xx/xx/xx'}`
      return `Version ${this.buildInfo.version || 'x.x.x'}`
    },
    toScreen() {
      return _.get(this.$route.query, 'screen');
    },
    toScope() {
      return _.get(this.$route.query, 'scope');
    }
  },
  async created() {
    await this.redirectIfNeeded();
  },
  async mounted() {
    try {
      this.buildInfo = (await axios.get(`appInfo`)).data
    } catch(e) {
      console.log(this.$cleanString(e))
    }
  },
}
</script>
